<template>
  <div class="head">
    <div class="head_in">
      <div class="top_shop_left">
        <ul>
          <li>
            <el-dropdown @command="handleLang">
              <span class="el-dropdown-link">
                <span v-if="locale === 'en'">English</span>
                <span v-if="locale === 'zh'">简体中文</span>
                <span v-if="locale === 'zh_HK'">繁體中文</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item, index) in langList"
                  :key="index"
                  :command="item.name"
                >{{ item.label }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li v-if="areaList.length" style="margin-left: 10px">
            <el-dropdown @command="handleArea">
              <span class="el-dropdown-link">
                {{ areaList[currencyarea].label }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item, index) in areaList"
                  :key="index"
                  :command="item.name"
                >{{ item.label }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
      </div>
      <div class="top_shop_right">
        <ul>
          <li v-show="!isLogin">
            <router-link to="/login">{{ lang.please_sign }}</router-link>
          </li>
          <li v-show="!isLogin">
            <router-link to="/register" style="color:#EC9221">{{ lang.register }}</router-link>
          </li>
          <li v-show="isLogin">
            {{ lang.welcome }}
            <router-link to="/user/index" style="color:#EC9221">{{user.nickname}}</router-link>
          </li>
          <li v-show="isLogin">|</li>
          <li v-show="isLogin">
            <router-link to="/user/index">{{ lang.personal_center }}</router-link>
          </li>
          <li v-show="isLogin">|</li>
          <li v-show="isLogin" @click="logout()">
            <router-link to>{{ lang.logout }}</router-link>
          </li>
          <li>
            <router-link to="/goods/collect">{{ lang.favorites }}</router-link>
          </li>
          <li>
            <router-link to="/help">{{ lang.help_center }}</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      user_info: {},
      langList: [
        {
          label: 'English',
          name: 1
        },
        {
          label: '简体中文',
          name: 2
        },
        {
          label: '繁體中文',
          name: 3
        }
      ],
      locale: localStorage.getItem('locale') || 'zh_HK',
      areaList: [
        {
          label: this.$t('public_head').macao,
          name: 0
        },
        {
          label: this.$t('public_head').mainland,
          name: 1
        }
      ]
    }
  },
  computed: {
    lang() {
      return this.$t('public_head')
    },
    ...mapGetters(['isLogin', 'user', 'currencyarea'])
  },
  methods: {
    logout() {
      this.$confirm(this.lang.tips_content, this.lang.tips, {
        confirmButtonText: this.lang.confirm_text,
        cancelButtonText: this.lang.cancel_text,
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('logout')
        this.$router.push('/login')
      })
    },
    handleArea(e) {
      this.$store.state.user.currencyarea = e
      sessionStorage.setItem('currencyarea', e)
      if (e === 1) {
        this.$store.state.user.unit = 'RMB'
        sessionStorage.setItem('unit', 'RMB')
      } else {
        this.$store.state.user.unit = 'MOP'
        sessionStorage.setItem('unit', 'MOP')
      }
      this.$router.go(0)
    },
    handleLang(e) {
      if (e === 1) {
        // this.$i18n.locale = 'en'
        this.locale = 'en'
        localStorage.setItem('locale', 'en')
      } else if (e === 2) {
        // this.$i18n.locale = 'zh'
        this.locale = 'zh'
        localStorage.setItem('locale', 'zh')
      } else {
        // this.$i18n.locale = 'zh_HK'
        this.locale = 'zh_HK'
        localStorage.setItem('locale', 'zh_HK')
      }
      location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
.head {
  border-bottom: 1px solid #efefef;
  height: 34px;
  background: #ffffff;
  font-size: 12px;
  line-height: 34px;
  .head_in {
    width: 1200px;
    margin: 0 auto;
    .top_shop_left {
      float: left;
      ul li {
        float: left;
        padding: 0 5px;
        cursor: pointer;
      }
    }
    .top_shop_right {
      float: right;
      ul li {
        float: left;
        padding: 0 8px;
      }
      li:hover {
        color: #ec9221;
      }
    }
  }
  .head_in:after {
    display: block;
    clear: both;
    content: '';
  }
  .head_in a:hover {
    color: #ec9221;
  }
}
</style>